import { supabase, isSupabaseConfigured } from './supabase';
import { getEntityFlagUrl } from '../utils/entityFlagImages';

let cachedEntities = null;

/**
 * Distinct countries from map_entities for quick-pick team selection.
 * @returns {Promise<Array<{ entityCode: string, name: string, flagUrl: string | null }>>}
 */
export async function fetchMapEntityCountries() {
  if (cachedEntities) return cachedEntities;
  if (!isSupabaseConfigured) {
    cachedEntities = [];
    return cachedEntities;
  }

  const { data, error } = await supabase
    .from('map_entities')
    .select('entity_code, entity_name')
    .order('entity_name');

  if (error) {
    console.warn('Failed to load map entities:', error.message);
    cachedEntities = [];
    return cachedEntities;
  }

  const seen = new Set();
  cachedEntities = (data ?? [])
    .filter((row) => {
      const key = row.entity_code;
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .map((row) => ({
      entityCode: row.entity_code,
      name: row.entity_name,
      flagUrl: getEntityFlagUrl(row.entity_code),
    }));

  return cachedEntities;
}
